"use client";

import { c as _c } from "react/compiler-runtime";
import { useContext } from "react";
import { ApiCreateGroup } from "@/generated/models/ApiCreateGroup";
import { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import { AuthContext } from "@/components/auth/Auth";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
import GroupCreateTest from "./GroupCreateTest";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import SecondaryButton from "@/components/utils/button/SecondaryButton";
import { SubmitArgs, useGroupMutations } from "@/hooks/groups/useGroupMutations";
export default function GroupCreateActions(t0) {
  const $ = _c(38);
  const {
    originalGroup,
    groupConfig,
    onCompleted
  } = t0;
  const {
    requestAuth,
    setToast,
    connectedProfile
  } = useContext(AuthContext);
  const {
    onGroupCreate
  } = useContext(ReactQueryWrapperContext);
  let t1;
  if ($[0] !== onGroupCreate || $[1] !== requestAuth) {
    t1 = {
      requestAuth,
      onGroupCreate
    };
    $[0] = onGroupCreate;
    $[1] = requestAuth;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    validate,
    submit,
    isSubmitting
  } = useGroupMutations(t1);
  let t2;
  if ($[3] !== groupConfig || $[4] !== validate) {
    t2 = validate(groupConfig);
    $[3] = groupConfig;
    $[4] = validate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const validation = t2;
  const isActionsDisabled = !validation.valid || isSubmitting;
  let t3;
  if ($[6] !== connectedProfile?.handle || $[7] !== groupConfig || $[8] !== isSubmitting || $[9] !== onCompleted || $[10] !== originalGroup || $[11] !== setToast || $[12] !== submit) {
    t3 = async () => {
      if (isSubmitting) {
        return;
      }
      const submitArgs = {
        payload: groupConfig,
        previousGroup: originalGroup,
        currentHandle: connectedProfile?.handle ?? null
      };
      const result = await submit(submitArgs);
      if (result.ok) {
        setToast({
          message: "Group created.",
          type: "success"
        });
        onCompleted();
        return;
      }
      if (result.reason === "auth") {
        return;
      }
      setToast({
        message: result.error,
        type: "error"
      });
    };
    $[6] = connectedProfile?.handle;
    $[7] = groupConfig;
    $[8] = isSubmitting;
    $[9] = onCompleted;
    $[10] = originalGroup;
    $[11] = setToast;
    $[12] = submit;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const onSave = t3;
  let t4;
  if ($[14] !== groupConfig || $[15] !== isActionsDisabled) {
    t4 = <GroupCreateTest groupConfig={groupConfig} disabled={isActionsDisabled} />;
    $[14] = groupConfig;
    $[15] = isActionsDisabled;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[17] !== onCompleted) {
    t5 = <SecondaryButton onClicked={() => onCompleted()}>Cancel</SecondaryButton>;
    $[17] = onCompleted;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  const t6 = `${isActionsDisabled ? "" : "tw-from-primary-400 tw-to-primary-500"}  tw-bg-gradient-to-b tw-p-[1px] tw-flex tw-rounded-lg`;
  const t7 = `${isActionsDisabled ? "tw-opacity-50 tw-text-iron-300" : "tw-text-white hover:tw-bg-primary-600 hover:tw-border-primary-600"} tw-flex tw-items-center tw-whitespace-nowrap tw-border tw-border-solid tw-border-primary-500 tw-rounded-lg tw-bg-primary-500 tw-px-3.5 tw-py-2.5 tw-text-sm tw-font-semibold tw-shadow-sm focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-offset-2 focus-visible:tw-outline-primary-600 tw-transition tw-duration-300 tw-ease-out`;
  let t8;
  if ($[19] !== isSubmitting) {
    t8 = isSubmitting && <CircleLoader />;
    $[19] = isSubmitting;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span>Create</span>;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t8) {
    t10 = <div className="tw-flex tw-items-center tw-justify-center tw-gap-x-2">{t8}{t9}</div>;
    $[22] = t8;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== isActionsDisabled || $[25] !== onSave || $[26] !== t10 || $[27] !== t7) {
    t11 = <button onClick={onSave} disabled={isActionsDisabled} type="button" className={t7}>{t10}</button>;
    $[24] = isActionsDisabled;
    $[25] = onSave;
    $[26] = t10;
    $[27] = t7;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t11 || $[30] !== t6) {
    t12 = <div className={t6}>{t11}</div>;
    $[29] = t11;
    $[30] = t6;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t12 || $[33] !== t5) {
    t13 = <div className="tw-flex tw-items-center tw-gap-x-3">{t5}{t12}</div>;
    $[32] = t12;
    $[33] = t5;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t13 || $[36] !== t4) {
    t14 = <div className="tw-mt-6"><div className="tw-flex tw-items-center tw-justify-between tw-gap-x-3">{t4}{t13}</div></div>;
    $[35] = t13;
    $[36] = t4;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  return t14;
}